import { type ReactNode } from 'react'
import { cn } from '@/lib/utils'

/**
 * Animating one continuous property (`grid-template-rows` 0fr → 1fr) is what lets a fast toggle reverse cleanly
 * from wherever it is, unlike a DOM insert/remove. Children stay mounted (inert when collapsed) so their form
 * state survives. Put the leading/trailing gap INSIDE `children` so it collapses too and leaves no empty slot.
 */
export function Collapse(props: { open: boolean; children: ReactNode; className?: string }) {
  return (
    <div
      className={cn(
        'grid transition-[grid-template-rows] duration-300 ease-out motion-reduce:transition-none',
        props.open ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]',
        props.className,
      )}
    >
      <div className="overflow-hidden" inert={!props.open}>
        {props.children}
      </div>
    </div>
  )
}
